import { styled } from "styled-components";

import { ProgressBar } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getAIGeneratedMapProgress, getIsAIGeneratedMapFetching } from "domains/createMapDetail/selectors";
import { FakeProgressStatuses } from "domains/createMapDetail/types";
import { interpolate } from "domains/language/interpolate";

const StyledLoadingTimeLeftText = styled.div`
  margin-top: 1rem;
`;

export const AIPromptProgress = () => {
  const isFetching = useSelector(getIsAIGeneratedMapFetching);
  const progress = useSelector(getAIGeneratedMapProgress);
  const translate = useTranslate();

  const FAKE_STATUSES = {
    [FakeProgressStatuses["Not started"]]: {
      percentage: 0,
      timeLeft: "0",
      text: "",
    },
    [FakeProgressStatuses.Preparing]: {
      percentage: 10,
      timeLeft: "10",
      text: translate("app.ai_map.status.preparing"),
    },
    [FakeProgressStatuses.Selecting]: {
      percentage: 50,
      timeLeft: "6",
      text: translate("app.ai_map.status.selecting"),
    },
    [FakeProgressStatuses.Finalizing]: {
      percentage: 70,
      timeLeft: "2",
      text: translate("app.ai_map.status.finalizing"),
    },
    [FakeProgressStatuses.Finish]: {
      percentage: 100,
      timeLeft: "1",
      text: translate("app.ai_map.status.almost_ready"),
    },
  };

  const getTimeRemainingText = (s: string) => FAKE_STATUSES[progress.status].timeLeft + s;
  const timeRemainingText = interpolate(translate("app.ai_map.time_remaining"), {
    numberOfSeconds: getTimeRemainingText,
  });

  return (
    <>
      {progress && isFetching && (
        <div>
          <h3>{translate("app.ai_map.generating_map")}</h3>
          <ProgressBar
            percentage={FAKE_STATUSES[progress.status].percentage}
            text={FAKE_STATUSES[progress.status].text}
          />
          <StyledLoadingTimeLeftText>{timeRemainingText}</StyledLoadingTimeLeftText>
        </div>
      )}
    </>
  );
};
